
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x-stream",
      function () {
        return require("private-next-pages/x-stream/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x-stream"])
      });
    }
  